module.exports = __webpack_public_path__ + "public/Icons/twitter.png?ff702f9d";